import { Component, OnInit, Input, OnChanges, EventEmitter, Output } from '@angular/core';
import { ILabel } from '../ILabel.model';
import { ActivatedRoute } from '@angular/router';
import { TranslationService } from '../common/services/translation.service';
import { CpqStyle } from '../common/models/CpqStyles.model';
import { TooltipPosition } from '@angular/material/tooltip';

@Component({
    selector: 'cpq-info',
    templateUrl: './cpq-info.component.html',
    styleUrls: ['./cpq-info.component.scss'],
    standalone: false
})
export class CpqInfoComponent implements OnInit, OnChanges {
  @Input('message') message: ILabel;
  @Input('position') position?: TooltipPosition;
  @Output('onInfoClick') onInfoClick = new EventEmitter<any>();
  @Input('customStyle') customStyle = new CpqStyle();

  public msg = '';

  constructor(public route: ActivatedRoute, public translationService: TranslationService) { }

  ngOnInit() {
    if (!this.position) {
      this.position = 'after';
    }
  }

  ngOnChanges() {
    if(this.message.value) {
      this.msg = this.message.value;
    } else if (this.message.key) {
      this.msg = this.translationService.translate(this.message.key);
    }
  }

  infoClicked() {
    this.onInfoClick.emit();
  }
}
